module Meevo.Plugins.VisitNoteTypes {
  "use strict";

  /**
  * Main Section of Visit Note Type 
  */
  export class MainSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<Model.VisitNoteType> {

   /**
   * Base class override which defines what a DEFAULT model looks like.
   */
    createSectionModelInstance(postAdd:(data:any)=>any): void {
      this.dataService.getTemplate(this.baseEndpoint).then((data) => {
        this.model = data;
      });
    }

  }

}